import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/reset.css";
import "./index.css";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd";
import { setNavigateToChannel } from "./store/common/chatSlice";
import {
  generalSlice,
  incrementUnreadNotificationsCount,
  setInfo,
  setSwRegistrationForLoginCase,
} from "./store/common/generalSlice";
import notificationTone from "../src/assets/audios/ding-notification.m4a";
import { isSupported } from "firebase/messaging";

const BASEPATH = process.env.REACT_APP_BASE_NAME;
console.log("index", BASEPATH);

const queryClient = new QueryClient();

const Root = () => {
  const [swRegistration, setSwRegistration] = useState(null);

  useEffect(() => {
    const checkSupport = async () => {
      const supported = await isSupported();
      if (!supported) {
        return;
      }

      // Proceed with FCM token generation logic
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register(`${BASEPATH}firebase-messaging-sw.js`)
          .then((registration) => {
            console.log("Service Worker registered:", registration.scope);
            setSwRegistration(registration);
            navigator.serviceWorker.onmessage = (event) => {
              console.log(event);
              const notificationData = event?.data?.data?.data;
              // means its a foreground notification.
              if (!event?.data?.type) {
                console.log("foreground");
                if (notificationData?.includes("channelId")) {
                  if (!window?.location?.pathname.includes("chat")) {
                    store.dispatch(setInfo("You have received a new message"));
                  }
                } else if (event?.data?.notification) {
                  const parsedData = JSON.parse(notificationData || "{}");
                  if (parsedData?.notificationId) {
                    store.dispatch(
                      incrementUnreadNotificationsCount(parsedData),
                    );
                  }
                  store.dispatch(setInfo(event?.data?.notification?.body));
                }
              }
              // means its a bg notification i.e type is added from sw.js file.
              else {
                console.log("background");
                if (event.data?.type === "NOTIFICATION_CLICK") {
                  store.dispatch(setNavigateToChannel(true));
                } else if (event.data?.type === "BOOKING_NOTIFICATION") {
                  const notificationData = JSON.parse(event.data?.data?.data);
                  if (notificationData.notificationId) {
                    store.dispatch(
                      incrementUnreadNotificationsCount(notificationData),
                    );
                    const audio = new Audio(notificationTone);
                    audio
                      .play()
                      .catch((err) =>
                        console.warn("Audio playback failed:", err),
                      );
                  }
                }
              }
            };
          })
          .catch((err) =>
            console.error("Service Worker registration failed:", err),
          );
      }
    };

    checkSupport();
  }, []);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="*" element={<App swRegistration={swRegistration} />} />,
    ),
    {
      basename: BASEPATH,
    },
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ConfigProvider
            theme={{
              token: {
                fontFamily: "Poppins, sans-serif",
              },
            }}
          >
            <RouterProvider router={router} />
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);

reportWebVitals();
